import { create } from "zustand";
import { persist } from "zustand/middleware";

import { LightingOption, MaterialModeOption } from "./types";

const STORAGE_KEY = "model-viewer-settings";

interface ViewerSettingsStore {
  lightingIntensity: number;
  setLightingIntensity: (lightingIntensity: number) => void;
  lightingType: LightingOption;
  setLightingType: (lightingType: LightingOption) => void;
  showLightSource: boolean;
  setShowLightSource: (showLightSource: boolean) => void;
  materialMode: MaterialModeOption;
  setMaterialMode: (v: MaterialModeOption) => void;
}

export const useModelViewerSettings = create<ViewerSettingsStore>()(
  persist(
    (set) => ({
      lightingIntensity: 1.5,
      setLightingIntensity: (intensity: number) => {
        set({
          lightingIntensity: intensity,
        });
      },
      lightingType: "DIRECTIONAL",
      setLightingType: (option: LightingOption) => {
        set({
          lightingType: option,
        });
      },
      showLightSource: false,
      setShowLightSource: (showSource: boolean) => {
        set({
          showLightSource: showSource,
        });
      },
      materialMode: "textured",
      setMaterialMode: (mode: MaterialModeOption) => {
        set({
          materialMode: mode,
        });
      },
    }),
    {
      name: STORAGE_KEY,
    },
  ),
);
